import type { TechFormSubmissionDraft } from "../models/tech-form-submission-data.models";
import { TECH_FORM_STORAGE_OPTIONS } from "../models/tech-form-vessel-cache.constants";
import { reviveTq5PortCallDate } from "../utils/revive-tq5-port-call-date.utils";
import { atom } from "jotai";
import { atomWithStorage, createJSONStorage, RESET } from "jotai/utils";

const tq5PortCallsStorage = createJSONStorage<any>(() => localStorage, { reviver: reviveTq5PortCallDate });

export const techFormStepCountAtom = atomWithStorage<number>(
  "techFormsetpCount",
  0,
  undefined,
  TECH_FORM_STORAGE_OPTIONS,
);

export const tq1VesselDetailsAtom = atomWithStorage<any>("tq1VesselDetails", {}, undefined, TECH_FORM_STORAGE_OPTIONS);
export const tq2DesignDetailsAtom = atomWithStorage<any>("tq2DesignDetails", {}, undefined, TECH_FORM_STORAGE_OPTIONS);
export const tq3DraftAtom = atomWithStorage<any>("tq3Draft", {}, undefined, TECH_FORM_STORAGE_OPTIONS);
export const tq3DraftTableAtom = atomWithStorage<any>("tq3DraftTable", {}, undefined, TECH_FORM_STORAGE_OPTIONS);
export const tq4AntiFoulingDetailsAtom = atomWithStorage<any>(
  "tq4AntiFoulingDetails",
  {},
  undefined,
  TECH_FORM_STORAGE_OPTIONS,
);
export const tq5PortCallsAtom = atomWithStorage<any>(
  "tq5PortCalls",
  {},
  tq5PortCallsStorage,
  TECH_FORM_STORAGE_OPTIONS,
);
export const tq6SecaAtom = atomWithStorage<any>("tq6Seca", {}, undefined, TECH_FORM_STORAGE_OPTIONS);
export const tq7SlowStreamingAtom = atomWithStorage<any>("tq7SlowStreaming", {}, undefined, TECH_FORM_STORAGE_OPTIONS);
export const tq8PowerManagementAtom = atomWithStorage<any>(
  "tq8PowerManagement",
  {},
  undefined,
  TECH_FORM_STORAGE_OPTIONS,
);
export const tq8PowerManagementTableAtom = atomWithStorage<any>(
  "tq8PowerManagementTable",
  {},
  undefined,
  TECH_FORM_STORAGE_OPTIONS,
);

export const setTechFormSubmissionDraftAtom = atom(null, (_get, set, draft: TechFormSubmissionDraft) => {
  set(tq1VesselDetailsAtom, draft.tq1VesselDetails);
  set(tq2DesignDetailsAtom, draft.tq2DesignDetails);
  set(tq3DraftAtom, draft.tq3Draft);
  set(tq3DraftTableAtom, draft.tq3DraftTable);
  set(tq4AntiFoulingDetailsAtom, draft.tq4AntiFoulingDetails);
  set(tq5PortCallsAtom, draft.tq5PortCalls);
  set(tq6SecaAtom, draft.tq6Seca);
  set(tq7SlowStreamingAtom, draft.tq7SlowStreaming);
  set(tq8PowerManagementAtom, draft.tq8PowerManagement);
  set(tq8PowerManagementTableAtom, draft.tq8PowerManagementTable);
});

export const resetTechFormStorageAtom = atom(null, (_get, set) => {
  set(techFormStepCountAtom, RESET);
  set(tq1VesselDetailsAtom, RESET);
  set(tq2DesignDetailsAtom, RESET);
  set(tq3DraftAtom, RESET);
  set(tq3DraftTableAtom, RESET);
  set(tq4AntiFoulingDetailsAtom, RESET);
  set(tq5PortCallsAtom, RESET);
  set(tq6SecaAtom, RESET);
  set(tq7SlowStreamingAtom, RESET);
  set(tq8PowerManagementAtom, RESET);
  set(tq8PowerManagementTableAtom, RESET);
});
